import { useRef, useState } from "react"
import { EventStatusBadge, SimplePlaceholder, SearchInput } from "@components"
import { formattedDateRange, mySqlToLocal } from "@helpers"
import { CircleStackIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const SessionList = ({ handleChangeSession, sessions }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const searchInputRef = useRef(null)

  const handleClearSearch = () => {
    searchInputRef.current.parentNode.querySelector('[data-slot="clear-button"]').click()
    setSearchTerm("")
  }

  const handleSearchChange = searchTerm => {
    setSearchTerm(searchTerm);  
  }

  const filteredSessions = sessions.filter(session => session.title.toLowerCase().includes(searchTerm.toLowerCase()))
  
  return (
    <div>
      <SearchInput
        innerRef={searchInputRef}
        classNames="mb-3"
        debounceMilliSeconds={0}
        placeholder="Search by title"
        handleChange={searchTerm => handleSearchChange(searchTerm)}
        handleClear={() => setSearchTerm("")}
      />

      {filteredSessions.length === 0 && (
        <SimplePlaceholder icon={CircleStackIcon} title="No sessions found">
          <div>
            <p className="mt-1 text-sm text-gray-500">
              No sessions found. Try a different search term.
            </p>

            <Button className="mt-4" color="secondary" fullWidth onPress={() => handleClearSearch()}>
              Clear Search
            </Button>
          </div>
        </SimplePlaceholder>
      )}

      <ul className="divide-y divide-content2-foreground divide-dotted">
        {filteredSessions.map(session => {
          const startDate = mySqlToLocal(session.starts_at)
          const endDate = mySqlToLocal(session.ends_at)

          return (
            <li key={session.id} className="flex items-center justify-between cursor-pointer" onClick={() => handleChangeSession(session)}>
              <div className="flex items-center py-3">
                <Square3Stack3DIcon className="mr-3 text-foreground w-14 h-14" />
                
                <div className="flex flex-col mr-4">
                  <h1 className="font-semibold leading-6 text-foreground text-md">{session.title}</h1>
                  <p className="text-sm text-content2-foreground">{formattedDateRange(startDate, endDate)}</p>
                </div>
              </div>
              
              <EventStatusBadge 
                size="sm" 
                startDate={session.starts_at} 
                endDate={session.ends_at} 
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

SessionList.propTypes = {
  handleChangeSession: PropTypes.func.isRequired,
  sessions: PropTypes.array.isRequired,
}

export default SessionList
